[
    {
        "Plan Name": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            }
        },
        "Season": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            }
        },
        "Created At": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            }
        },
        "Created By": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            }
        },
        "Last Modified": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "sort": "desc"
        },
        "Last Modified By": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            }
        },
        "Profile Gen": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "hide": true
        },
        "Reco Quantification": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            }
        },
        "Open": {
            "editable": false,
            "refData": {
                "datatype": "action-button|open",
                "showTooltip": false,
                "displayBlankHeader": true
            },
            "pinned": "none"
        },
        "Delete": {
            "editable": false,
            "refData": {
                "datatype": "action-button|delete",
                "showTooltip": false,
                "displayBlankHeader": true
            },
            "pinned": "none"
        }
    }
]
